import { render, staticRenderFns } from "./OnboardingStep00.vue?vue&type=template&id=77b034bc&scoped=true&"
import script from "./OnboardingStep00.vue?vue&type=script&lang=js&"
export * from "./OnboardingStep00.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStep00.vue?vue&type=style&index=0&id=77b034bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b034bc",
  null
  
)

export default component.exports